import React, { useState } from "react";
import Carousel from "react-simply-carousel";

import { Document } from "@contentful/rich-text-types";

import { Card } from "../Card/Card";

type Props = {
  items: { title: string; description: Document | null }[];
};

export const CarouselCards: React.FC<Props> = ({ items }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  return (
    <Carousel
      preventScrollOnSwipe={false}
      swipeTreshold={60}
      activeSlideIndex={activeSlide}
      onRequestChange={setActiveSlide}
      itemsToShow={6}
      speed={400}
      centerMode={false}
      infinite={false}
      hideNavIfAllVisible={true}
      forwardBtnProps={{ show: false }}
      backwardBtnProps={{ show: false }}
      dotsNav={{
        show: items.length > 5,
        containerProps: {
          style: {
            justifyContent: "center",
            alignItems: "center",
            marginTop: "32px",
            width: "100%",
            display: "flex"
          }
        },
        itemBtnProps: {
          style: {
            height: 12,
            width: 12,
            borderRadius: "50%",
            border: 0,
            background: "#00386380",
            marginRight: 10
          }
        },
        activeItemBtnProps: {
          style: {
            height: 16,
            width: 16,
            borderRadius: "50%",
            border: 0,
            background: "#FFD41C",
            marginRight: 10
          }
        }
      }}
      containerProps={{
        style: {
          justifyContent: "space-between",
          userSelect: "none",
          maxWidth: "none"
        }
      }}
      itemsListProps={{
        style: {
          touchAction: "none",
          minWidth: "1200px",
          maxWidth: "none"
        }
      }}
      responsiveProps={[
        {
          itemsToShow: 2,
          itemsToScroll: 1,
          maxWidth: 600,
          dotsNav: { show: true }
        },
        {
          itemsToShow: 4,
          itemsToScroll: 1,
          maxWidth: 1280,
          dotsNav: {
            show: true,
            containerProps: {
              style: {
                justifyContent: "center",
                alignItems: "center",
                marginTop: "32px",
                width: "100%",
                display: "flex"
              }
            },
            itemBtnProps: {
              style: {
                height: 12,
                width: 12,
                borderRadius: "50%",
                border: 0,
                background: "#00386380",
                marginRight: 10
              }
            },
            activeItemBtnProps: {
              style: {
                height: 16,
                width: 16,
                borderRadius: "50%",
                border: 0,
                background: "#FFD41C",
                marginRight: 10
              }
            }
          }
        }
      ]}
    >
      {items?.map((item, index) => (
        <Card key={index} {...item} />
      ))}
    </Carousel>
  );
};
